import * as React from 'react';
import { useDispatch } from 'react-redux';
import { DriverRegistrationPortalNoAuthService } from '@gen/driverRegistration/driverRegistrationPortalNoAuth';
import { isFormUploading } from '../redux/form/formSelectors';
import { useSelector } from '../redux/store';
import { postForm } from '../redux/form/formThunk';
import { Button } from './Button';

interface NextButtonProps {
  step: DriverRegistrationPortalNoAuthService.Step;
  text: string;
}

export const NextButton: React.FC<NextButtonProps> = ({
  step,
  text,
}: NextButtonProps) => {
  const inputId = 'next';

  const dispatch = useDispatch();
  const loading = useSelector(isFormUploading);
  return (
    <Button
      onClick={() => dispatch(postForm(step))}
      color={loading ? 'bg-green-200' : 'bg-green-500'}
      loadingTextColor="text-green-500"
      label={loading ? '' : text}
      disabled={loading}
      loading={loading}
      id={inputId}
    />
  );
};
